module.exports = __webpack_public_path__ + "img/l200Big.1ab9331d.png";